import { CSSObject } from '@emotion/react';
import { theme } from 'styles';

const selectedItem: CSSObject = {
  fontWeight: 700,
  background: theme.color.grey75,
  ':hover': { background: theme.color.grey75 },
};

const checkMark: CSSObject = {
  marginLeft: 'auto',
  paddingLeft: 12,
  boxSizing: 'content-box',
  color: theme.color.primary,
};

export { selectedItem, checkMark };
